import { SVGProps } from 'react';

const BrainCircuit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.401 6.5a3 3 0 0 1-.398-1.375A3 3 0 1 1 12 5v13M6.003 5.125a4 4 0 0 0-2.526 5.77m.585-.395a4 4 0 0 0-1.744 1.934 4 4 0 0 0 1.715 5.05m0 0A4 4 0 1 0 12 18m-7.967-.517c.6.339 1.278.517 1.967.517m6 0h6a2 2 0 0 1 2 2v1M9 13a4.5 4.5 0 0 0 3-4m0 4h4m-4-5h8m-4 0V5a2 2 0 0 1 2-2m-1.5 10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2-10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 18a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0-13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);
export default BrainCircuit;
